import React from "react";
import styled from "styled-components";
const StyledWrapper = styled.div`
  text-align: center;
  margin-bottom: 0.25rem;
`;

const Wrapper = ({
  children
}) => {
  return /*#__PURE__*/React.createElement(StyledWrapper, null, children);
};

export default Wrapper;